import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem,
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import sapImage from '../../../assets/images/Settings/sapImage.svg'
import oracleImage from '../../../assets/images/Settings/oracleImage.svg'
import { SbAddBtn } from '../../Buttons/Buttons';

const data = [
    {
        slNo: '1',
        CustomerName: 'Lobotus Technology Pvt Ltd',
        sapOroracle: '',
        totalCount: '10',
        lastSynchedDate: '12-02-2025 14:30:00',
    },
    {
        slNo: '2',
        CustomerName: 'ANADATHA PESTICEDS AND FERTILIZER',
        sapOroracle: '',
        totalCount: '15',
        lastSynchedDate: '12-02-2025 15:45:00',
    },
    {
        slNo: '3',
        CustomerName: 'amuruthalakshmi fertilizer and pesticides',
        sapOroracle: '',
        totalCount: '8',
        lastSynchedDate: '12-02-2025 16:20:00',
    },
    {
        slNo: '4',
        CustomerName: 'AMS RYTHU DEPOT --- PEDDAMUDIYAM',
        sapOroracle: '',
        totalCount: '12',
        lastSynchedDate: '12-02-2025 17:10:00',
    },
    {
        slNo: '5',
        CustomerName: 'Epsilon Enterprises',
        sapOroracle: '',
        totalCount: '20',
        lastSynchedDate: '12-02-2025 18:25:00',
    },
];

const columns = [
    { id: 'slNo', label: 'SL No', align: 'left', minWidth: "100px" },
    { id: 'CustomerName', label: 'CUSTOMER NAME', align: 'left', minWidth: "350px" },
    { id: 'sapOroracle', label: 'ERP', align: 'left' },
    { id: 'totalCount', label: 'TOTAL COUNT', align: 'left', minWidth: "120px" },
    { id: 'lastSynchedDate', label: 'LAST SYNCHED DATE', align: 'left', minWidth: "180px" },
    { id: 'action', label: 'ACTION', align: 'left' },
];

const RestDataSourceCustomerTable = ({
    handleTotalCountClick,
    handleSapClick,
    handleOracleClick,
    handleOpenModal,
    handleAdd
}) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container">
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className="table-header-div">
                                    {column.label}
                                    {column.id === 'slNo' && (
                                        <IconButton
                                            size="small"
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            <img src={SortIcon} alt="Sort" />
                                        </IconButton>
                                    )}
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((customer, index) => (
                        <TableRow key={index}>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                    {column.id === 'sapOroracle' ? (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {index % 2 === 0 ? ( // Alternate based on row index
                                                <div
                                                    style={{ cursor: 'pointer', color: 'blue', width: "100px" }}
                                                    onClick={() => handleSapClick(customer)}
                                                    onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
                                                    onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                                                >
                                                    <img src={sapImage} style={{ width: "35%" }} alt="SAP" />
                                                </div>
                                            ) : (
                                                <div
                                                    style={{ cursor: 'pointer', color: 'blue', width: "200px" }}
                                                    onClick={() => handleOracleClick(customer)}
                                                    onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
                                                    onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                                                >
                                                    <img src={oracleImage} style={{ width: "35%" }} alt="Oracle" />
                                                </div>
                                            )}
                                        </div>
                                    ) : column.id === 'totalCount' ? (
                                        <span
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => handleTotalCountClick(customer)}
                                        >
                                            {customer[column.id]}
                                        </span>
                                    ) : column.id === 'action' ? ( // Action column logic
                                        <SbAddBtn
                                            btnName="Add"
                                            // onClickEffect={() => handleOpenModal(customer)}
                                            onClickEffect={handleAdd}
                                        />
                                    ) : (
                                        customer[column.id]
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" /> Ascending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" /> Descending
                </MenuItem>
            </Menu>
        </TableContainer >
    );
};

export default RestDataSourceCustomerTable;
